import { createListenerMiddleware } from "@reduxjs/toolkit";
import { createApi } from "@reduxjs/toolkit/query/react";
import { logout } from "@/features/auth/slice";
import { COMMUNITY_UNAVAILABLE, communityBaseQuery, resetCommunityPass } from "./baseQuery";

export const COMMUNITY_TAG_TYPES = ["CommunityPosts", "CommunityMe"] as const;

export const communityApi = createApi({
  reducerPath: "communityApi",
  baseQuery: communityBaseQuery,
  tagTypes: [...COMMUNITY_TAG_TYPES],
  endpoints: () => ({}),
});

export const communitySessionListener = createListenerMiddleware();

communitySessionListener.startListening({
  actionCreator: logout,
  effect: function resetCommunitySession(_action, listenerApi) {
    resetCommunityPass();
    listenerApi.dispatch(communityApi.util.resetApiState());
  },
});

export { COMMUNITY_UNAVAILABLE, communityBaseQuery, resetCommunityPass };
